import React from 'react';
import senaiLogo from '@assets/images/senai-branca.webp';

function Senai() {
  return <img src={senaiLogo} alt='Logo do SENAI' />;
}

export default Senai;
